/*
 * Copyright © 2023-2024 www.4bex.com
 *
 * Licensed under the www.4bex.com License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.4bex.com/license
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { useState } from 'react';
import "../google-auth/GoogleAuth.css";
import { Button, Divider, Typography, message } from "antd";
import { useGoogleLogin } from '@react-oauth/google';
import { useGoogleAuthMutation } from './useGoogleAuthMutation';
import UseAuth from "../../hooks/UseAuth";
import googleIcon from "../../../assests/images/google.svg";

const GoogleAuth = ({ onSuccessNavigation }) => { //get the navigation function from props
   const [isLoading, setIsLoading] = useState(false);
   const { setAuth } = UseAuth();

   const googleAuthMutation = useGoogleAuthMutation();

   const login = useGoogleLogin({
      flow: 'auth-code',
      onSuccess: async (codeResponse) => {
         setIsLoading(true);
         try {
            const response = await googleAuthMutation.mutateAsync(codeResponse.code);
            const { userId, userType, accessToken, refreshToken, success } = response;

            setAuth({ userId, userType, accessToken, refreshToken });

            message.success(success?.message || "Logged in successfully");

            onSuccessNavigation(userType); // Call the navigation function with userType

         } catch (err) {
            const errorMsg =
               err?.response?.data?.error?.message ||  //if error object has response, if response has data, if data has error show the message
               err?.response?.data?.message || //if error object has response, if response has data, show the message
               "Login failed. Please try again.";
            message.error(errorMsg);

         } finally {
            setIsLoading(false);
         }
      },

      onError: (error) => {
         setIsLoading(false);
         message.error("Google login failed. Please try again.");
      },
   });

   const handleGoogleLogin = () => {
      login();
   };

   return (
      <div className="container">
         <Divider
            style={{ borderColor: '#d9d9d9', borderWidth: 2 }}
            orientation="center"
         >
            <Typography.Text style={{ color: '#8c8c8c' }}>OR</Typography.Text>
         </Divider>

         <div className="google-btn-container">
            <Button
               type="text"
               className="google-auth-btn"
               icon={<img src={googleIcon} alt="Google" className="google-icon" />}
               block
               onClick={handleGoogleLogin}
               loading={isLoading}
            >
               <Typography.Text className="google-btn-text">
                  {isLoading ? 'Signing in...' : 'Continue with Google'}
               </Typography.Text>
            </Button>
         </div>
      </div>
   );
};

export default GoogleAuth;
